import { SET_USER, SetUserAction, User } from './types';

export function setUser(user: User | null): SetUserAction {
	return {
		type: SET_USER,
		payload: user,
	};
}
